import React from 'react';
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';
import { FaEnvelope } from 'react-icons/fa';
import NodeCardShell from '../Components/NodeCardShell';
import { cleanTemplateName } from '../Components/nodeSummary';

const TEMPLATE_NODE_COLOR = '#00A884';

const Template = ({ data, isConnectable, id, selected }) => {
  useSyncNodeInternals(id, `${data.saved}~${data.first}`);

  const templateName = cleanTemplateName(data.template_name);
  const paramsCount = data.parametersBody?.length || 0;
  const summary = templateName
    ? `${templateName}${paramsCount ? ` · ${paramsCount} parámetro${paramsCount !== 1 ? 's' : ''}` : ''}`
    : '';

  return (
    <NodeCardShell
      icon={FaEnvelope}
      color={TEMPLATE_NODE_COLOR}
      typeName="Plantilla"
      title={data.title ?? 'Enviar Plantilla'}
      summary={summary}
      trigger={data.user_response}
      error={data?.error}
      selected={selected}
      first={data.first}
      handles={
        <>
          {!data.first && data.saved && (
            <Handle
              type="target"
              position={Position.Top}
              isConnectable={isConnectable}
              id={`target-${id}`}
              style={{ backgroundColor: TEMPLATE_NODE_COLOR }}
            />
          )}
          {data.saved && (
            <Handle
              type="source"
              position={Position.Bottom}
              isConnectable={isConnectable}
              id={`source-${id}`}
              style={{ backgroundColor: TEMPLATE_NODE_COLOR }}
            />
          )}
        </>
      }
    />
  );
};

export default React.memo(Template);
